module.exports = __webpack_public_path__ + "static/media/slide-image-4-large-min-new.0205f1cf.jpg";